export default __webpack_public_path__ + "static/media/coach_wrong.e7f4b8ee.png";